import { useTranslation } from 'react-i18next';
import { Logo } from '../Brand/Logo.js';

export function LoadingScreen() {
  const { t } = useTranslation();
  return (
    <div
      className="flex min-h-screen items-center justify-center bg-background"
      role="status"
      aria-label={t('common.loading')}
    >
      <Logo className="animate-loading-pulse h-14" />
    </div>
  );
}
